import script from "./DrawerDocumentaryRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./DrawerDocumentaryRecord.vue?vue&type=script&lang=ts&setup=true"

import "./DrawerDocumentaryRecord.vue?vue&type=style&index=0&id=3b474fa6&lang=scss&scoped=true"
import "./DrawerDocumentaryRecord.vue?vue&type=style&index=1&id=3b474fa6&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b474fa6"]])

export default __exports__